<template>
  <div>
    <b-modal
      no-fade
      size="xl2"
      id="modal-consolidacao"
      no-close-on-esc
      no-close-on-backdrop
      title="Consolidação"
    >
      <b-form-row>
        <b-col>
          <b-tabs
            content-class="v-tab-content"
            v-model="tabIndex"
            active-nav-item-class="v-tab-active"
            small
          >
            <b-tab title="Financeiro">
              <TabFinanceiro ref="tabFinanceiro" :wbs="wbs" :acao="acao" :sintetico="true" />
            </b-tab>
            <b-tab title="Planejamento">
              <SubTabPlanejamentoSintetico ref="tabPlanejamento" :wbs="wbs" />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-form-row>
      <template v-slot:modal-footer>
        <b-button size="sm" @click="() => $bvModal.hide('modal-consolidacao')"
          >Fechar</b-button
        >
      </template>

    </b-modal>
  </div>
</template>

<script>
import SubTabPlanejamentoSintetico from "./SubTabPlanejamentoSintetico.vue";
import TabFinanceiro from "./TabFinanceiro.vue";
import barramento from '@/barramento';

export default {
  name: "ModalConsolidacao",
  props: {
    programa: { type: Object, required: true },
  },
  components: { SubTabPlanejamentoSintetico, TabFinanceiro },
  data: function() {
    return {
      tabIndex: 0,
      acao: "visualizar",
      wbs: {
        programa_id: this.programa.programa_id,
        wbs_id: "0"
      }
    };
  },
  methods: {
  },
  created(){
    barramento.$on("programaChanged", programa => {
      this.wbs.programa_id = programa.programa_id;
    });
  }

};
</script>

<style></style>
